import axios from 'axios';
import { CategoryDTO } from '../ducks/types';

const getCategoriesApi = async () => {
  const response = await axios.get(`api/Categories`);
  const categories: CategoryDTO[] = await response.data;

  return categories || [];
};

export default getCategoriesApi;
